<template>
  <ion-page>
    <ion-content fullscreen>
      <the-header />
      <div class="content-container">
        <div class="add-stories">
          <div class="add-stories-banner">
            <div class="add-stories-banner__title">
              {{ t('shareYourStory') }}
            </div>
            <div
              class="add-stories-banner__message"
              v-html="t('messages.addStoriesBannerMessageHTML')"
            ></div>
          </div>
          <base-button @click="handleGoToGoogleForm">
            {{ t('emailUs') }}
          </base-button>
          <div class="add-stories__footer-text">
            {{ t('addStoriesFooterText') }}
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonPage } from '@ionic/vue';

import BaseButton from '@/components/BaseButton.vue';
import TheHeader from '@/components/TheHeader.vue';
import { useInternalization } from '@/composables/useInternalization';

const { t } = useInternalization();

function handleGoToGoogleForm() {
  window.open('mailto:support@feelyou.com', '_blank');
}
</script>

<style lang="scss" scoped>
.content-container {
  padding-bottom: 6em;
}

.add-stories {
  max-width: 600px;
  margin: 0 auto;

  &-banner {
    padding: 24px 16px;
    background: #dff8e6;
    border-radius: 20px;
    margin-bottom: 1em;
    margin-top: 2em;

    &__title {
      font-weight: 600;
      font-size: 20px !important;
      line-height: 24px !important;
      margin-bottom: 16px;
      color: #172659;
      display: flex;
      align-items: center;

      ion-icon {
        margin-left: 5px;
      }
    }

    &__message {
      :deep(p) {
        font-size: 15px;
        line-height: 20px;
        color: #172659;
        margin-bottom: 8px;
      }
    }
  }

  &__footer-text {
    font-size: 13px;
    line-height: 18px;
    color: #172659;
    text-align: center;
    text-wrap: balance;
    padding: 0px 16px;
    margin-top: 16px;
  }
}
</style>
